<h1 mat-dialog-title>Reset flight legs?</h1>
<div mat-dialog-content>
  Resetting the flight legs will remove all current legs from this flight. Only do this if you want
  to re-enter information for all legs.
</div>
<div mat-dialog-actions>
  <button mat-raised-button (click)="dialogRef.close('reset')">
    <mat-icon>clear</mat-icon> Reset Legs
  </button>
  <button mat-raised-button (click)="dialogRef.close('cancel')">
    <mat-icon>cancel</mat-icon> Cancel
  </button>
</div>
